module.exports = __webpack_public_path__ + "img/login_bg.d3abba98.png";